/* eslint-disable max-len */
/**
 * Italian translations.
 */
export default {
  ACTION: {
    CANCEL: 'Cancella',
    CONFIRM: 'Conferma',
    NEW_INVOICE: 'Nuova fattura'
  },
  ERROR: {
    ACCUMULATE_SUBMITTED: 'Errore nell\'invio dell\'accumulo',
    CANCEL_ACCUMULATION: 'Errore nella cancellazione dell\'accumulo',
    CANCEL_INVOICE: 'Errore nella cancellazione della fattura',
    COUPON_CANCELED: 'Errore nella cancellazione del coupon',
    COUPON_GENERATED: 'Errore nella creazione del coupon',
    ERROR: 'Errore',
    INVOICE_SUBMITTED: 'Errore nell\'invio della fattura'
  },
  HEADER: {
    ACCU_REMUNERATION: 'Retribuzione accumulata',
    ATTACHMENT: 'Allegato',
    CHALLENGE: 'Sfida',
    COUPON: 'Coupon',
    COUPON_CODE: 'Codice coupon',
    DECISION: 'Decisione',
    MONTH: 'Mese',
    OBSERVATIONS: 'Osservazioni',
    REMUNERATION: 'Retribuzione',
    STATE: 'Stato',
    SUBMISSION_DATE: 'Data dell\'invio'
  },
  LABEL: {
    ACCUMULATE: 'Accumula',
    ACCUMULATED: 'Accumulato',
    ACTIVES: 'Attivi',
    ALL: 'Tutti',
    BEGIN_DATE: 'Data di inizio',
    CANCEL: 'Annulla',
    CANCEL_ACCUMULATION: 'Annulla accumulo',
    CANCEL_COUPON: 'Annulla coupon',
    CANCEL_INVOICE: 'Annulla fattura',
    CLOSE: 'Chiudi',
    CODE: 'Codice',
    CONFIRM: 'Conferma',
    CONFIRM_ACCUMULATE: 'Accumula',
    CONFIRM_COUPON_CREATION: 'Genera coupon',
    CONFIRM_SUBMIT_INVOICE: 'Invia',
    COPY_COUPON_CODE: 'Copia codice coupon',
    COUPON: 'Coupon',
    COUPON_CODE: 'Codice coupon',
    CURRENT_PERIOD: 'Periodo attuale',
    DATE: 'Data',
    DESCRIPTION: 'Descrizione',
    END_DATE: 'Data di fine',
    FILTER: 'Filtro',
    GENERATE_COUPON: 'Genera coupon',
    GO_TO_DETAILS: 'Dettagli',
    INVOICE: 'Fattura',
    MODEL: 'Modello',
    MONEY: 'Soldi',
    MONTH: 'Mese',
    NEW_INVOICE: 'Nuova fattura',
    PAYMENT_METHOD: 'Metodo di pagamento',
    PENDING_COUNTERPARTS: 'Contropartite in sospeso',
    PENDING_COUNTERPARTS_MODAL_TITLE: 'Contropartite in sospeso',
    PENDING_VALUE: 'Valore in sospeso',
    PREVIOUS_PERIOD: 'Periodo precedente',
    REMUNERATION: 'Retribuzione',
    SELECTED_PRODUCTS: 'Prodotti selezionati',
    STATE: 'Stato',
    SUBMIT_INVOICE_ATTACHMENT: 'Allegato (PDF)',
    SUBMIT_INVOICE_COMMENT: 'Commento',
    SUBMIT_MANUAL_REMUNERATION_INVOICE_VALUE: 'Valore',
    WITHOUT_PRODUCTS: 'Senza prodotti selezionati',
    YEAR: 'Anno'
  },
  SENTENCE: {
    CANCEL_ACCUMULATION: 'Sei sicuro di voler annullare l\'accumulo?',
    CANCEL_COUPON: 'Sei sicuro di voler annullare il coupon {value}?',
    CANCEL_INVOICE: 'Sei sicuro di voler annullare l\'invio della fattura?',
    CANT_GENERATE_COUPON: 'Non puoi generare questo coupon.',
    CANT_SUBMIT_REMUNERATION: 'Non puoi invire questa fattura',
    CONFIRM_SUBMIT_COUPON:
      'Stai per creare un coupon da {couponValue}. Desideri continuare?',
    EMPTY_TITLE: 'Nessun dato'
  },
  SUCCESS: {
    ACCUMULATE_SUBMITTED: 'Retribuzione accumulata',
    CANCEL_ACCUMULATION: 'Accumulo annullato',
    CANCEL_INVOICE: 'Fattura annullata',
    COUPON_CANCELED: 'Coupon annullato',
    COUPON_COPIED: 'Coupon copiato negli appunti',
    COUPON_GENERATED: 'Coupon creato con il codice %{value}',
    INVOICE_SUBMITTED: 'Fattura inviata',
    SUCCESS: 'Successo'
  },
  TOOLTIP: {
    ACCU_REMUNERATION: 'Retribuzione accumulata',
    ATTACHMENT: 'Allegato',
    CHALLENGE: 'Sfida',
    COUPON: 'Coupon',
    COUPON_CODE: 'Codice coupon',
    DECISION: 'Decisione',
    MONTH: 'Mese',
    OBSERVATIONS: 'Osservazioni',
    REMUNERATION: 'Retribuzione',
    STATE: 'Stato',
    SUBMISSION_DATE: 'Data di invio',
    SWIPE: 'Scorri a sinistra per vedere più colonne',
    VIEW_CHALLENGE_DETAILS: 'Vedi dettagli della sfida'
  }
};
